import useProto from '~/client/features/Proto/hooks/useProto';
import ProtoCommands from '~/client/features/Proto/utils/ProtoCommands';
import useCashierLink from '~/client/hooks/feature/useCashierLink';
import useFeature from '~/client/hooks/feature/useFeature';
import useRouter from '~/client/hooks/router/useRouter';
import useLoyaltyStore from '~/client/store/useLoyaltyStore';
import CommsCommands from '@/client/helpers/CommsCommands';

const useLoyaltyInAppLinkClicked = () => {
  const { replace } = useRouter();
  const { isProtoEnabled } = useProto();
  const isCommsEnabled = useFeature('comms');
  const { setLoyaltyOpen } = useLoyaltyStore();
  const { open: openCashierTransactions } = useCashierLink({
    cashierPath: 'transactions',
  });

  const handleLoyaltyInAppLinkClicked = (link: LinkType) => {
    setLoyaltyOpen({ isLoyaltyOpen: false });
    switch (link) {
      case 'transactionHistory':
        return openCashierTransactions?.();
      case 'liveSupport':
        if (isProtoEnabled) {
          return ProtoCommands.open();
        } else if (isCommsEnabled) {
          return CommsCommands?.show?.({});
        }
      case 'helpCenter':
        return replace(`/help-center`);
      case 'sendUsEmail':
        return replace(`/help-center?send_email=1`);
      default:
        return '';
    }
  };

  return {
    handleLoyaltyInAppLinkClicked,
  };
};
export default useLoyaltyInAppLinkClicked;
